import { blend, clamp } from './interpolate';

const scoreGrowth = (yoy) => {
  if (yoy < 0) return 20;
  if (yoy <= 0.05) return 20 + (yoy / 0.05) * (45 - 20);
  if (yoy <= 0.1) return 45 + ((yoy - 0.05) / 0.05) * (60 - 45);
  if (yoy <= 0.2) return 60 + ((yoy - 0.1) / 0.1) * (75 - 60);
  return clamp(75 + (yoy - 0.2) * 20, 75, 95);
};

const scoreVolatility = (cv) => {
  if (!Number.isFinite(cv) || cv < 0) return 50;
  if (cv <= 0.05) return 95;
  if (cv <= 0.1) return 95 - ((cv - 0.05) / 0.05) * (95 - 80);
  if (cv <= 0.15) return 80 - ((cv - 0.1) / 0.05) * (80 - 68);
  if (cv <= 0.25) return 68 - ((cv - 0.15) / 0.1) * (68 - 50);
  return clamp(50 - (cv - 0.25) * 100, 15, 50);
};

const scoreRevenueLevel = (log10Rev) => {
  if (!Number.isFinite(log10Rev)) return 15;
  if (log10Rev < 5) return 15;
  if (log10Rev <= 6) return 15 + (log10Rev - 5) * (45 - 15);
  if (log10Rev <= 7) return 45 + (log10Rev - 6) * (68 - 45);
  return clamp(68 + (log10Rev - 7) * 20, 68, 95);
};

export const scoreD1 = (inputs) => {
  const prior = inputs.prior12MRevenue;
  const yoy = prior > 0 ? (inputs.ttmRevenue - prior) / prior : 0;
  const cv = inputs.monthlyMean > 0 ? inputs.monthlyStdev / inputs.monthlyMean : 0.25;
  const ftaRatio = inputs.totalInvoiceCount > 0 ? clamp(inputs.ftaValidatedCount / inputs.totalInvoiceCount, 0, 1) : 0;
  const log10Rev = inputs.ttmRevenue > 0 ? Math.log10(inputs.ttmRevenue) : 0;

  const growth = scoreGrowth(yoy);
  const volatility = scoreVolatility(cv);
  const level = scoreRevenueLevel(log10Rev);
  const fta = ftaRatio * 100;

  const score = blend([
    { score: growth, weight: 0.35 },
    { score: volatility, weight: 0.25 },
    { score: level, weight: 0.2 },
    { score: fta, weight: 0.2 },
  ]);

  return { score, subScores: { growth, volatility, level, fta } };
};
